import { SonarObjectType } from '@sonar-software/sonar-ts-types';

export function shouldItemShowParent(type: SonarObjectType): boolean {
	return type === SonarObjectType.SalesforceField || type === SonarObjectType.PardotField;
}

export function shouldItemShowApiName(type: SonarObjectType): boolean {
	return type === SonarObjectType.SalesforceEntity;
}
